import React from "react";

const Notfound = () => {
  return (
    <div style={{ padding: "80px" }}>
      <h1>Not Found</h1>
    </div>
  );
};

export default Notfound;
